import React from "react";
import styles from "./NavBar.module.scss";
import classNames from "classnames";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import Button from "../UI/Buttons/Button/Button";
import CloseIcon from "@rsuite/icons/Close";
import {
  selectIsAdvisorSession,
  selectIsAssociationSession,
} from "../../store/auth-slice";
import AdvisorLogoutButton from "../AdvisorLogoutButton/AdvisorLogoutButton";
import AssociationLogoutButton from "../AssociationLogoutButton/AssociationLogoutButton";

type Props = {};

const DefaultLinkArray = [
  { label: "PROFIL", link: "/profile" },
  { label: "REZERVACIJE", link: "/order-processing" },
  { label: "MOJE AKTIVNOSTI", link: "/my-activity" },
];

const DriverLinkArray = [
  { label: "PROFIL", link: "/profile" },
  { label: "REZERVACIJE", link: "/order-processing" },
  { label: "REALIZOVANE REZERVACIJE", link: "/completed-reservations" },
  { label: "MOJE AKTIVNOSTI", link: "/my-activity" },
];

// ITAM-2677 / ITAM-2734: extra links for FAVOURITE_DELIVERY_USER, placed
// right after "PROFIL", in this order.
const FavouriteVolunteerLinkArray = [
  { label: "MOJ PROFIL OVLAŠĆENOG LICA", link: "/authorized-person-profile" },
  { label: "MOJI KORISNICI", link: "/my-customers" },
];

// ITAM-2887: the advisor persona navigates between its profile and the
// logout page only.
const AdvisorLinkArray = [
  { label: "PROFIL SAVETNIKA", link: "/advisor-profile" },
  { label: "ODJAVI SE", link: "/profile" },
];

// Association portal: the administered association, its advisor roster and
// the logout page.
const AssociationLinkArray = [
  { label: "UDRUŽENJE", link: "/association" },
  { label: "SAVETNICI", link: "/association/advisors" },
  { label: "ODJAVI SE", link: "/profile" },
];

function NavBar({ showNavbar, setShowNavbar }: any) {
  const roles = useSelector(
    (state: RootState) => state.auth.userInfo?.roles ?? [],
  );
  const isAdvisor = useSelector(selectIsAdvisorSession);
  const isAssociation = useSelector(selectIsAssociationSession);

  const baseLinks = roles.includes("DELIVERY_USER")
    ? DriverLinkArray
    : DefaultLinkArray;
  const volunteerLinks = roles.includes("FAVOURITE_DELIVERY_USER")
    ? [baseLinks[0], ...FavouriteVolunteerLinkArray, ...baseLinks.slice(1)]
    : baseLinks;
  const links = isAssociation
    ? AssociationLinkArray
    : isAdvisor
    ? AdvisorLinkArray
    : volunteerLinks;

  return (
    <div
      className={classNames(styles.navBarWrap, {
        [styles.open]: showNavbar,
      })}
    >
      <div
        onClick={() => setShowNavbar(false)}
        className={classNames(styles.overlay, {
          [styles.open]: showNavbar,
        })}
      />
      <div className={styles.content}>
        <div className={styles.header}>
          <img className={styles.logo} src="/logo.png" />

          <CloseIcon
            height={24}
            width={24}
            onClick={() => setShowNavbar(false)}
          />
        </div>

        <div className={styles.accountDetails}>
          <img className={styles.profileImage} src={"/profile.png"} />
          <div className={styles.doctorName}>
            {/* {doctorDetails?.firstName} {doctorDetails?.secondName} */}
            <br />
            <span style={{ fontWeight: "normal", fontSize: "12px" }}>
              {/* Broj licence: <b>{doctorDetails?.licenceNumber}</b> */}
            </span>
          </div>
        </div>
        <hr style={{ margin: "10px 0" }} />

        <div className={styles.linksWrap}>
          {links.map((item, i) => (
            <LinkWrap
              onClick={() => setShowNavbar(false)}
              label={item?.label}
              link={item?.link}
              key={i}
            />
          ))}
        </div>
        <hr style={{ margin: "10px 0" }} />

        {isAssociation ? (
          <AssociationLogoutButton
            onBeforeLogout={() => setShowNavbar(false)}
          />
        ) : isAdvisor ? (
          <AdvisorLogoutButton onBeforeLogout={() => setShowNavbar(false)} />
        ) : (
          <Button
            onClick={() => {
              localStorage.clear();
              window.location.reload();
            }}
            buttonType="white"
          >
            Odjavi se
          </Button>
        )}
      </div>
    </div>
  );
}

export default NavBar;

const LinkWrap = ({ label, link, onClick }: any) => {
  return (
    <Link onClick={onClick} className={styles.link} to={link}>
      {label}
    </Link>
  );
};
